// extracted by mini-css-extract-plugin
export var filterIncDec = "_bi-0";
export var leftBorder = "_bi-1";
export var rightBorder = "_bi-2";
export var stringInput = "_bi-3";